import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


const Information = () => {
  return (
    <Container>
    <h2 className="display-6 fw-bold my-4">Information for Authors</h2>
    <hr />
    <p className="joab-common-para my-4">
      Green Publication is a publisher of scholarly gold open access (OA) journals. All our journals have a peer-reviewed, rapid, and rigorous manuscript handling and editorial process.
    </p>
    <p className="joab-common-para mb-3">
      Green Publication gold open-access journals are the professional platform for you to publish your work under an open-access license, all in a fast and straightforward manner.
    </p>
    <p className="joab-common-para mb-3">
      Articles published in Green Publication journals are distributed under the terms of the Creative Commons Attribution License (CC-BY) which permits any use, distribution, and reproduction in any medium, provided the original author(s) and source are credited.
    </p>


  </Container>
  );
};

export default Information;
